import { Dialog, DialogContent, Stack, Typography } from '@mui/material';
import PaiSpinningLoader from 'features/ui/base-components/pai-spinning-loader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
}

const EnrichmentLoadingDialog: React.FC<Props> = ({ open }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'sm'}>
      <DialogContent className={classes.content}>
        <Stack gap={4}>
          <PaiSpinningLoader size="large" />
          <Stack gap={2}>
            <Typography className={classes.blueText} align="center">
              {t('sourcingPhoneNumbers')}
            </Typography>
            <Typography className={classes.greyText} align="center">
              {t('analyzingProfilesMessage')}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  content: {
    padding: '48px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  blueText: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
}));

export default EnrichmentLoadingDialog;
